import { Helmet } from "react-helmet";

const Meta = () => {
  return (
    <Helmet>
      <title>Randi.ai - Blogg</title>
      <meta name="thumbnail" content="https://randi.ai/showcase.jpg" />
      <meta name="robots" content="index, follow" />
      <meta
        name="description"
        content="Les om siste nytt av funksjonaliteter og andre relevante artikler om AI, transkribering og nyttige verktøy for å effektivisere arbeidet ditt."
      />
      <meta name="author" content="Randi.ai" />
      <meta
        name="keywords"
        content="Les om siste nytt av funksjonaliteter og andre relevante artikler om AI, transkribering og nyttige verktøy for å effektivisere arbeidet ditt."
      />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content="https://randi.ai/" />
      <meta name="twitter:title" content="Randi.ai - Blogg" />
      <meta name="twitter:description" content="" />
      <meta name="twitter:image" content="https://randi.ai/showcase.jpg" />

      <meta property="og:url" content="https://randi.ai/" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Randi.ai - Blogg" />
      <meta
        property="og:description"
        content="Les om siste nytt av funksjonaliteter og andre relevante artikler om AI, transkribering og nyttige verktøy for å effektivisere arbeidet ditt."
      />
      <meta property="og:image" content="https://randi.ai/showcase.jpg" />
      <link rel="canonical" href="https://randi.ai/" />
    </Helmet>
  );
};

export default Meta;
